<h2 class="text-center text-3xl font-bold md:text-2xl">
  {{ 'marketReports.statistics.title' | transloco: { name: this.name } }}
</h2>
<h3 class="mb-6 text-center">{{ 'marketReports.statistics.subtitle' | transloco }}</h3>
<mat-card
  class="mat-elevation-z4 grid grid-cols-2 gap-6 text-center md:grid-cols-4 print:border-0 print:bg-steel-5 print:p-4"
  appearance="outlined"
>
  @for (stat of statistics; track stat) {
    <div class="md:py-6">
      <div class="flex items-center justify-center gap-2">
        <rma-icon [glyph]="icons[stat.name]" />
        <span class="text-xl font-bold md:text-4xl print:text-2xl">{{ stat.value }}</span>
      </div>
      <div class="font-bold print:font-normal">{{ 'marketReports.statistics.type.' + stat.name | transloco }}</div>
    </div>
  }
</mat-card>
